import { SxProps, Theme } from '@mui/system';

const styles = {
  container: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    py: '8px',
    ml: '8px',
    px: '40px',
    backgroundColor: 'pharmacy.bookedLight',
    borderRadius: '4px',
    mt: '12px',
    mb: '6px',
  },
  label: {
    color: 'common.counterRed',
    fontSize: 16,
    fontWeight: '500',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
